import React, { useEffect } from 'react';
import { Box, Typography, Autocomplete, TextField, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';
import { countryList } from '../countryLists';

// Define styled components
const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  marginLeft: '15%',
  width: '100%',
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  
 maxWidth: '140px',
 width: '100%',
  '& .MuiAutocomplete-inputRoot': {
    padding: '2px',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '0px',
  },
}));

const StyledIconButton = styled(IconButton)({
  padding: '0px', // Remove padding
  position: 'absolute', // Ensure it stays in place
  right: '4px', // Adjust position as needed
});

function CustomDropdown({ label, inputValue, handleChange, handleSelect }) {
  const [countries, setCountries] = React.useState([]);

  useEffect(() => {
    if (inputValue) {
      // Filter the country list based on the input value
      const filteredCountries = countryList.filter((country) =>
        country.toLowerCase().includes(inputValue.toLowerCase())
      );
      setCountries(filteredCountries);
    } else {
      setCountries(countryList);
    }
  }, [inputValue]);


  const handleClear = () => {
    handleChange(null, '');
    setCountries(countryList); // Reset the list to show all countries
  };

  return (
    <StyledBox>
      <Typography>{label}</Typography>
      <StyledAutocomplete
        options={countries}
        value={inputValue}
        onChange={(event, newValue) => handleSelect(event, newValue)}
        clearOnEscape
        clearIcon={
          <StyledIconButton
            size="small"
            onClick={ handleClear}
          >
            <ClearIcon />
          </StyledIconButton>
        }
        clearText='Select Country'
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Select a country"
            onChange={(event) => handleChange(event, event.target.value)}
          />
        )}
      />
    </StyledBox>
  );
}

export default CustomDropdown;